import React, { useEffect, useMemo, useState } from "react";
import { v4 } from "uuid";
import AccessController from "_shared/AccessController";
import { DashGridL2 } from "layouts/dash-grid";
import TopBar from "_shared/Top";
import { CircularProgress, InputAdornment, TextField } from "@mui/material";
import { Toaster } from "react-hot-toast";
import { DataGrid } from "@mui/x-data-grid";
import DownloadIcon from "@mui/icons-material/Download";
import SearchIcon from "@mui/icons-material/Search";
import exportExcel from "utils/excelGenerate";
import { getVisitsStats } from "_controllers/officer";
import { toastMessage } from "utils/toastMessage";
import { useHistory } from "react-router-dom";

const Main = () => {
  const history = useHistory();

  const [pageSize, setPageSize] = useState(10);
  const [search, setSearch] = useState("");
  const [data, setData] = useState([]);
  const [visitData, setVisitData] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [loading, setLoading] = useState(true);

  const columns = useMemo(() => [
    {
      field: "SAP_ID",
      headerName: "SAP ID",
      flex: 1,
    },
    {
      field: "zone",
      headerName: "Zone",
      flex: 1,
    },
    {
      field: "region",
      headerName: "Region",
      flex: 2,
    },
    {
      field: "area",
      headerName: "Area",
      flex: 2,
    },
    {
      field: "planned",
      headerName: "Planned",
      flex: 1,
    },
    {
      field: "unplanned",
      headerName: "Unplanned",
      flex: 1,
    },
    {
      field: "Prospect Visits",
      headerName: "Prospect",
      flex: 1,
    },
    {
      field: "Customer Visits",
      headerName: "Customer",
      flex: 1,
    },
    {
      field: "Influencer Visits",
      headerName: "Influencer",
      flex: 1,
    },
  ]);

  const handleChange = (e) => {
    setSearch(e.target.value);
  };

  useEffect(async () => {
    await getVisitsStats()
      .then((d) => {
        const test = d?.usersWithStats.map((user) => ({
          id: v4(),
          SAP_ID: user.SAP_ID,
          zone: user.zone ? user.zone : "-",
          region: user.regionName ? user.regionName : "-",
          area: user.areaName ? user.areaName : "-",
          territory: user.territoryName ? user.territoryName : "-",
          planned: user?.stats?.planned || 0,
          unplanned: user?.stats?.unplanned || 0,
          "Prospect Visits": user?.prospect?.count || 0,
          "Customer Visits": user?.customer?.count || 0,
          "Influencer Visits": user?.influencer?.count || 0,
        }));
        setVisitData(test);
        setLoading(false);
      })
      .catch((err) => {
        console.log("err", err);
        setLoading(false);
        toastMessage("error fetching data", "error");
      });
  }, []);

  useEffect(() => {
    const res = visitData
      .filter(
        (data) =>
          data?.SAP_ID?.toUpperCase().includes(search.toUpperCase()) ||
          data?.zone?.toUpperCase().includes(search.toUpperCase()) ||
          data?.region?.toUpperCase().includes(search.toUpperCase()) ||
          data?.area?.toUpperCase().includes(search.toUpperCase())
      )
      .map((user) => ({
        id: user?.id,
        SAP_ID: user?.SAP_ID,
        zone: user?.zone ? user.zone : "-",
        region: user?.region ? user.region : "-",
        area: user?.area ? user.area : "-",
        // territory: user.territoryName ? user.territoryName : "-",
        planned: user?.planned || 0,
        unplanned: user?.unplanned || 0,
        "Prospect Visits": user?.["Prospect Visits"] || 0,
        "Customer Visits": user?.["Customer Visits"] || 0,
        "Influencer Visits": user?.["Influencer Visits"] || 0,
      }));
    setSearchData(res);
  }, [search]);

  let fileName = "Visits-Stats";

  const generateExcel = async (e) => {
    e.preventDefault();
    exportExcel(
      visitData.map((x) => ({
        "SAP ID": x?.SAP_ID,
        Zone: x?.zone,
        Region: x?.region,
        Area: x?.area,
        "Planned Visits": x?.planned,
        "Unplanned Visits": x?.unplanned,
        "Prospect Visits": x["Prospect Visits"],
        "Customer Visits": x["Customer Visits"],
        "Influencer Visits": x["Influencer Visits"],
      })),
      fileName
    );
  };

  return (
    <>
      <div style={{ width: "98%", marginTop: "2.5rem", marginBottom: "2rem" }}>
        {/* <Grid>
          <h2>Visit Stats</h2>
        </Grid> */}
        <div
          style={{
            paddingBottom: "1rem",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center ",
          }}
        >
          <TextField
            onChange={handleChange}
            value={search}
            name="search"
            variant="outlined"
            label="SAP ID or Territory"
            // fullWidth
            sx={{ width: "93%" }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
          <DownloadIcon
            sx={{
              border: "1px solid darkgrey",
              fontSize: "55px",
              borderRadius: "3px",
              cursor: "pointer",
            }}
            onClick={generateExcel}
          />
        </div>

        {loading ? (
          <CircularProgress />
        ) : (
          <DataGrid
            rows={search ? searchData : visitData}
            columns={columns}
            autoHeight={true}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            onRowClick={(data) => history.push(`/SO/${data.row.SAP_ID}/visits`)}
            className="TableCell"
            rowsPerPageOptions={[10, 25, 50, 100]}
            sx={{ fontSize: "0.75rem" }}
          />
        )}
      </div>
      <Toaster />
    </>
  );
};

const VisitStats = () => {
  return (
    <AccessController roles={["AO", "RO", "ZO", "ADMIN"]}>
      <DashGridL2 Top={TopBar} Main={Main} />
      <Toaster />
    </AccessController>
  );
};

export default VisitStats;
